import './App.css';
import './cmpt/cmpt.css';
import Head from './cmpt/head';
import Bloglist from './cmpt/bloglist';

function App() {
	return (
		<div className='App'>
			<Head />
			<Bloglist />
		</div>
	);
}

export default App;
